export default "__VITE_ASSET__fpylUuqG__"